import { Pipe, PipeTransform } from '@angular/core';
import { isNil, Nillable } from '@web/utils';

@Pipe({
  name: 'boolean',
  standalone: true,
})
export class BooleanPipe implements PipeTransform {
  public transform(
    value: Nillable<boolean>,
    labelIfTrue = 'Tak',
    labelIfFalse = 'Nie',
  ): Nillable<string> {
    if (isNil(value)) {
      return value;
    }

    return value ? labelIfTrue : labelIfFalse;
  }
}
